<div class="modal-content">
    <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
    <div class="modal-header">
        <h3 class="modal-title font">Historial de errores</h3>

        <div class="d-flex gap-3">
          <button  type="button" (click)="exportar()"
          class="btn btn-primary " data-toggle="modal">Exportar</button>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
    </div>

    <div class="bg-second-table-info pt-3 pb-5">
  <div *ngIf="flagSearch; else messageClear" class="container">
    <div class="card-tabla-proy">
      <div class="card-body">
        <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
          <div class="datatable-container table-responsive">
             <!--TABLA Listado con resultados de búsqueda--> 
            <lib-ge-table [headArray]="currentHeadArray" [gridArray]="gridArray"></lib-ge-table>
            <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
              <div class="d-flex mt-2">
                <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                  (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                </ngb-pagination>
              </div>
            </div>
             <!--FIN TABLA Listado con resultados de búsqueda-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #messageClear>
    <div class="mensaje-container">
      <p class="mensaje-linea">No hay resultados de errores para esta campaña.</p>
    </div>
  </ng-template>
</div>
</div>